import React, { useState } from 'react';
import { VegaAccordion, VegaBox, VegaDivider, VegaFlex, VegaFont } from '@globalpayments/vega-react';
import { Card } from '../../UserLookup/components/CardProps';
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

interface Props {
  info: Card;
}

const Infoinfo: React.FC<Props> = ({ info }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dateCreated = format(toZonedTime(info.createdUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');
  const dateLastUpdate = format(toZonedTime(info.lastUpdatedUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');
  const dateSessionExpired = format(toZonedTime(info.sessionExpirationUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');

  return (
    <VegaAccordion
      accordionTitle={`Email: ${info.email} | Config Name: ${info.configName}`}
      drawsBackground
      expand={isExpanded}
      expandIconAlign="right"
      onVegaExpand={(event) => setIsExpanded(event.detail)}
      showExpandIcon>
      <VegaBox padding={{ top: 'size-16' }} slot="accordion-content">
        <VegaFlex direction="col" gap="size-8">
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Application UID:</strong> {info.appUid}
          </VegaFont>
          <VegaDivider />
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Created: </strong>
            {dateCreated}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Last Updated: </strong>
            {dateLastUpdate}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>OnDemand Config Id: </strong>
            {info.onDemandConfigId}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Subflow Name: </strong>
            {info.currentSubflowName}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Subflow Id: </strong>
            {info.currentSubflowId}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Phase Name: </strong>
            {info.currentPhaseName}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Phase Id: </strong>
            {info.currentPhaseId}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Status: </strong>
            {info.latestStatus}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Current Status Detail: </strong>
            {info.latestStatusDetails}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Application Expired Date: </strong>
            {dateSessionExpired}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>AA Id: </strong>
            {info.aaid} {info.partnerName || ''}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Affiliate Id: </strong>
            {info.affiliateId}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>{info.isEmailVerified ? 'Email Verified' : 'Email Not Verified'}</strong>
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Email Verdict: </strong>
            {info.emailVerdict}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>{info.isOptedOut ? 'Opted Out' : 'Opted In'}</strong>
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>{info.isDisqualified ? 'Disqualified' : 'Not Disqualified'}</strong>
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>{info.isCompleted ? 'Completed' : 'Not Completed'}</strong>
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>{info.isLeadConverted ? 'Lead is Converted' : 'Lead Not Converted'}</strong>
          </VegaFont>
        </VegaFlex>
      </VegaBox>
    </VegaAccordion>
  );
};

export default Infoinfo;
